import { createSlice } from "@reduxjs/toolkit";
import {
    getOperators,
    createOperator,
    updateOperator,
    getOperatorUsers,
    updateUserPassword
} from "./thunk";

const initialState = {
    operators: [],
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 1
    },
    loading: false,
    actionLoading: false, // For create/update actions
    error: null,
    currentOperatorUsers: { // For storing users of a specific operator
        operatorId: null,
        operatorName: "",
        totalUsers: 0,
        users: [],
        loading: false
    },
    filters: {
        page: 1,
        limit: 10,
        search: ""
    }
};

const operatorsSlice = createSlice({
    name: "operators",
    initialState,
    reducers: {
        setOperatorFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetOperatorState: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // Get Operators
        builder.addCase(getOperators.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getOperators.fulfilled, (state, action) => {
            state.loading = false;
            // Check for success or status === 1 (common pattern in this app)
            if (action.payload && (action.payload.success || action.payload.status === 1)) {
                state.operators = action.payload.data.operators || [];
                state.pagination = action.payload.data.pagination || state.pagination;
            }
        });
        builder.addCase(getOperators.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // Create Operator
        builder.addCase(createOperator.pending, (state) => {
            state.actionLoading = true;
        });
        builder.addCase(createOperator.fulfilled, (state) => {
            state.actionLoading = false;
        });
        builder.addCase(createOperator.rejected, (state) => {
            state.actionLoading = false;
        });

        // Update Operator
        builder.addCase(updateOperator.pending, (state) => {
            state.actionLoading = true;
        });
        builder.addCase(updateOperator.fulfilled, (state) => {
            state.actionLoading = false;
        });
        builder.addCase(updateOperator.rejected, (state) => {
            state.actionLoading = false;
        });

        // Get Operator Users
        builder.addCase(getOperatorUsers.pending, (state) => {
            state.currentOperatorUsers.loading = true;
        });
        builder.addCase(getOperatorUsers.fulfilled, (state, action) => {
            state.currentOperatorUsers.loading = false;
            if (action.payload && (action.payload.success || action.payload.status === 1)) {
                state.currentOperatorUsers = {
                    ...state.currentOperatorUsers,
                    ...action.payload.data,
                    loading: false
                };
            }
        });
        builder.addCase(getOperatorUsers.rejected, (state) => {
            state.currentOperatorUsers.loading = false;
        });

        // Update User Password
        builder.addCase(updateUserPassword.pending, (state) => {
            state.actionLoading = true;
        });
        builder.addCase(updateUserPassword.fulfilled, (state) => {
            state.actionLoading = false;
        });
        builder.addCase(updateUserPassword.rejected, (state) => {
            state.actionLoading = false;
        });
    },
});

export const { setOperatorFilters, resetOperatorState } = operatorsSlice.actions;
export default operatorsSlice.reducer;
